export const headerFontColor = '#5E5F61'
export const editContainerFontColor = '#211F20'
export const dragIconColor = '#C9C9C9'
export const buttonHoverColor = '#EBEBEB'
export const blueButtonMainColor = '#13B5EA'
export const blueButtonBorderColor = '#0069AA'
export const blueButtonBGColor = 'rgba(19, 181, 234, 0.25)'
export const blueButtonBorderStyle = `1px solid ${blueButtonBorderColor}`
export const closeButtonBGColor = '#04797C'
export const closeButtonHoveredColor = '#036063'
export const masterPrimary = '#10B091'
export const tvBlueLinkButtonColor = '#0098D6'
export const tvProductNameTextColor = '#212529'
export const tvProductNameTextHoverColor = '#007bff'
export const customerNoteColor = '#04325B'
export const deltekNoteColor = '#0098D6'
export const deltekNoteHoverColor = '#0088D6'
export const dialogActionHR = '#696969'
export const internalNoteColor = '#AD0F0F'
export const viewOnlyHeaderColor = '#3B3B3B'
export const viewOnlyBorderColor = '#8B8B8B'
export const viewOnlyBackgroundColor = '#5E5F61'
export const hasUnreadNotesColor = '#10B091'
export const paginationSectionFontColor = '#595959'